function ChannelPlatform() {
  this.ad_id = '';
}

ChannelPlatform.prototype = {
  constructor: ChannelPlatform,
};

export default ChannelPlatform;



// WEBPACK FOOTER //
// ./src/common/js/model/ChannelPlatform.js